'use client';

import { useGTM } from './useGTM';

export function InitGTMConsent({ trackingCode }: { trackingCode: string }) {
  useGTM(trackingCode);
  return null;
}
